import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-master-testing-menu-dialog',
  templateUrl: './master-testing-menu-dialog.component.html',
  styleUrls: ['./master-testing-menu-dialog.component.scss']
})
export class MasterTestingMenuDialogComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<MasterTestingMenuDialogComponent>,
  ) { }

  ngOnInit() {
  }

}
